/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebclosed2Inputs */

const en_placewebclosed2 = /** @type {(inputs: Placewebclosed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const de_placewebclosed2 = /** @type {(inputs: Placewebclosed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlossen`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Placewebclosed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebclosed2 = /** @type {((inputs?: Placewebclosed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebclosed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebclosed2(inputs)
	return de_placewebclosed2(inputs)
});
export { placewebclosed2 as "placeWebClosed" }